import { PsModalTuner } from 'stencilSetup';
import { PlanPopupStyled } from './PlanPopupStyled';
import { PopupContentDto } from 'enrollment/features/ToDoList/types';
import { PlanPopupContent } from './PlanPopupContent';

interface PlanPopupProps {
  planId: number;
  popupContent?: PopupContentDto;
  apiHost: string;
  onClose: () => void;
}

export const PlanPopup = ({
  planId,
  popupContent,
  apiHost,
  onClose,
}: PlanPopupProps) => {
  return (
    <PlanPopupStyled>
      <PsModalTuner
        data-testid={`plan-popup-${planId}`}
        modalId={`plan-popup-${planId}`}
        modalTitle="Important Information"
        onPsModalSubmit={onClose}
        onPsModalDismiss={onClose}
        secondaryButton="Close"
      >
        <PlanPopupContent popupContent={popupContent} apiHost={apiHost} />
      </PsModalTuner>
    </PlanPopupStyled>
  );
};
